module.exports = {
  allowedRoutes: [
    'welcome',
    'unsubscribe',
    'get-help',
    'my-referrals',
  ],
}
